import { render, staticRenderFns } from "./MarketingEmailHeaderCreate.vue?vue&type=template&id=0e2a8682&scoped=true"
import script from "./MarketingEmailHeaderCreate.vue?vue&type=script&lang=js"
export * from "./MarketingEmailHeaderCreate.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailHeaderCreate.vue?vue&type=style&index=0&id=0e2a8682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a8682",
  null
  
)

export default component.exports